<div class="flex flex-col gap-2">
  <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
    {{ label() | transloco }}
    @if (isRequired()) {
      <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
    }
    @if (tooltipKey()) {
      <app-directus-tooltip class="ml-2" [tooltipKey]="tooltipKey()" />
    }
    <ng-content select="[labelBadge]" />
  </label>

  @if (isReadOnly()) {
    <input
      pInputText
      [value]="(value().length || 0) + ' ' + ('multiselect.selected' | transloco)"
      [disabled]="true"
      class="w-full"
    />
  } @else {
    <p-multiSelect
      [id]="id()"
      [options]="selectTranslatedOptions()"
      [ngModel]="value()"
      (ngModelChange)="onValueChange($event)"
      optionValue="id"
      [placeholder]="placeholder() | transloco"
      [filter]="hasFilterText()"
      [filterBy]="'filterText'"
      [showClear]="showClear()"
      class="w-full"
      [ngClass]="{'p-invalid': showInvalid()}"
      appendTo="body"
      (onBlur)="markAsTouched()"
    >
      <ng-template #item let-item>
        <div class="flex items-center gap-3">
          @if (showCountryFlags()) {
            <span class="fi fi-{{ item.id | lowercase }}"></span>
          }
          <span>{{ item.translations | translateDirectus }}</span>
          @if (item.tooltip?.key) {
            <app-directus-tooltip
              tooltipStyleClass="tooltip-bg-second-level"
              [tooltipKey]="item.tooltip?.key"
            ></app-directus-tooltip>
          }
        </div>
      </ng-template>

      <ng-template #selecteditems let-selectedOptions>
        @if (selectedOptions?.length > 0) {
          {{ selectedOptions.length }} {{ 'multiselect.selected' | transloco }}
        }
      </ng-template>
    </p-multiSelect>
  }

  @if (showSelectionLabel()) {
    <app-multi-selection-label
      [noSelectKey]="noSelectKey()"
      [options]="selectTranslatedOptions()"
      [selectedIds]="selectedIds()"
      [isReadOnly]="isReadOnly()"
      (remove)="removeSelection($event)"
    />
  }
</div>
